import React from 'react'
import { useMutation } from '@apollo/client'
import { AddTestSessionMembers } from '../../types'
import { ADD_TEST_SESSION_MEMBERS } from './operations'

export type MemberType = 'participant' | 'staff'

export interface UseAddTestSessionMembers {
  testSessionId: string
  groupId?: string
  memberType: MemberType | null
}

export const useAddTestSessionMembers = ({
  testSessionId,
  memberType,
  groupId,
}: UseAddTestSessionMembers) => {
  const [addTestSessionMembers, addTestSessionMembersData] = useMutation<AddTestSessionMembers>(
    ADD_TEST_SESSION_MEMBERS
  )

  const addTestSessionMembersWithInput = React.useCallback(
    (userIds: string[]) =>
      addTestSessionMembers({
        variables: {
          id: testSessionId,
          inputData: {
            userIds,
            groupId,
            isParticipant: memberType === 'participant',
            isStaff: memberType === 'staff',
          },
        },
      }),
    [addTestSessionMembers, groupId, testSessionId, memberType]
  )

  return {
    addTestSessionMembers,
    addTestSessionMembersData,
    addTestSessionMembersWithInput,
  }
}
